import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessment } from 'src/screens/shared/application/assessment/ProjectApplicationAssessment'

export const PfKapApplicationAssessmentIndexPage = (): ReactElement => {
  const { projectId } = useParams()
  const pfKapId = parseInt(projectId as string)
  return <ProjectApplicationAssessment projectId={pfKapId} baseUrl="/pf-kap" />
}
